export default __webpack_public_path__ + "static/media/bobo.bfe93685.jpeg";